import { render, staticRenderFns } from "./ELCard.vue?vue&type=template&id=55d92ab0"
import script from "./ELCard.vue?vue&type=script&lang=js"
export * from "./ELCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports